import React, { Component } from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';

import EntityValue from './EntityValue';

import { deleteEntity } from './EntityAPI';

class Entity extends Component {
  state = { 

  }

  handleEntityClicked = (e) => {
    const { setUpdateTargetEntity } = this.props;
    const { updateID } = this.props;

    // const { id } = setUpdateTargetEntity;
    // const { updateID } = setUpdateTargetEntity;
    // const { entityName } = setUpdateTargetEntity;
    // const { entityArray } = setUpdateTargetEntity;
    setUpdateTargetEntity(updateID);
  }

  handleDeleteBtnOnClicked = (e) => {
    // 삭제 유저 Confirm
    if (!window.confirm("삭제하시겠습니까?")) {
      // Disable entity row clicked event
      e.stopPropagation();
      return;
    }

    const {updateID} = this.props;
    
    deleteEntity(this.callBackGetEntity, updateID);

    // Disable entity row clicked event
    e.stopPropagation();
  }

  callBackGetEntity = (response) => {
		
    const {data} = response;
    const {statusCode} = data;

    switch(statusCode) {
      case 200:
      const {updateID} = this.props;
      const {deleteEntity} = this.props;

      deleteEntity(updateID);
      break;

      case 403:
      const { subCode } = data;
			switch(subCode) {
				case 0:
				alert("접근할 수 없는 토픽입니다.");
				break;

				case 1:
				alert("존재하지 않는 엔티티입니다. ");
				break;

				default:
				alert("에러가 발생하였습니다.");
			}
      break;

      case 500:
      alert("서버에서 에러가 발생하였습니다. 잠시 후 다시 시도해주세요");
      break;

      default:
      alert("에러가 발생하였습니다.");
      break;
    }
	}

  renderEntityList = (entityList) => {
    // entityList.length === 0

    if (entityList.length === 0) {
      return (
        <p> 엔티티 값이 존재하지 않습니다. </p>
      );
    }
    const renderedEntityArray = entityList.map( entity => {
      return (
        <EntityValue 
          value ={entity} />
      );
    });
    return renderedEntityArray;
  }

  render() {
    const {handleEntityClicked} = this;
    const {handleDeleteBtnOnClicked} = this;
    const {renderEntityList} = this;

    const {props} = this;
    const {entityName} = props;
    const {entityArray} = props;

    // let splitedEntityArray = null;

    const renderedEntityArray = renderEntityList(entityArray);

    return (
      <div className="global-entity row"
        onClick={handleEntityClicked}>
        <div className="title">
          <h2 className="value"> 
            {entityName} 
            <button className="btn btn-danger delete-entity-btn"
              onClick={handleDeleteBtnOnClicked} >
              <FontAwesomeIcon icon={faTrashAlt} />
            </button>
          </h2>
        </div>
        <div className="content">
          {renderedEntityArray}
        </div>
      </div>
    );
  }
}

export default Entity;